// extracted by mini-css-extract-plugin
export default {"star":"app-ted-star-button_star__h2KYQ","starred":"app-ted-star-button_starred__VObJO"};